(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sb-trial-countdown"] && !Shopify.designMode) return;
  try {
    class SBTrialCountdown extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.mode = this.dataset.mode || 'deadline';
      this.onExpire = this.dataset.expire || 'zero';
      this.showDays = this.dataset.showDays === 'true';

      this.out = {
        d: this.querySelector('[data-sbtc-d]'),
        h: this.querySelector('[data-sbtc-h]'),
        m: this.querySelector('[data-sbtc-m]'),
        s: this.querySelector('[data-sbtc-s]'),
        time: this.querySelector('[data-sbtc-time]')
      };

      this.end = this.resolveEnd();
      if (!this.end) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    storageKey() {
      return 'sbtc:' + (this.id || 'default');
    }

    resolveEnd() {
      if (this.mode === 'session') {
        const mins = parseFloat(this.dataset.minutes) || 15;
        let end = null;

        try {
          const saved = localStorage.getItem(this.storageKey());
          if (saved) end = parseInt(saved, 10);
        } catch (e) {
          /* private mode or blocked storage — fall through to a fresh window */
        }

        const valid = end && !isNaN(end);

        /* An expired window stays expired unless the block is set to restart,
           so a reload cannot silently grant more time than the copy promised. */
        if (valid && end > Date.now()) return end;
        if (valid && this.onExpire !== 'restart') return end;

        end = Date.now() + mins * 60000;
        try {
          localStorage.setItem(this.storageKey(), String(end));
        } catch (e) {
          /* nothing to do: the timer still runs for this page view */
        }
        return end;
      }

      const raw = (this.dataset.deadline || '').trim();
      if (!raw) return null;
      const parsed = Date.parse(raw.indexOf('T') === -1 ? raw.replace(' ', 'T') : raw);
      return isNaN(parsed) ? null : parsed;
    }

    static pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    /* MM:SS, growing to H:MM:SS and Dd H:MM:SS only when needed */
    static clock(total) {
      const pad = SBTrialCountdown.pad;
      const d = Math.floor(total / 86400);
      const h = Math.floor((total % 86400) / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      if (d > 0) return d + 'd ' + h + ':' + pad(m) + ':' + pad(s);
      if (h > 0) return h + ':' + pad(m) + ':' + pad(s);
      return pad(m) + ':' + pad(s);
    }

    tick() {
      let left = this.end - Date.now();

      if (left <= 0) {
        left = 0;
        clearInterval(this.timer);

        if (this.onExpire === 'hide') {
          this.hidden = true;
          return;
        }

        if (this.onExpire === 'restart' && this.mode === 'session') {
          const mins = parseFloat(this.dataset.minutes) || 15;
          this.end = Date.now() + mins * 60000;
          try {
            localStorage.setItem(this.storageKey(), String(this.end));
          } catch (e) {}
          this.timer = setInterval(this.tick.bind(this), 1000);
          return;
        }
      }

      const total = Math.floor(left / 1000);

      if (this.out.time) {
        this.out.time.textContent = SBTrialCountdown.clock(total);
        return;
      }

      let days = Math.floor(total / 86400);
      let hours = Math.floor((total % 86400) / 3600);
      const mins = Math.floor((total % 3600) / 60);
      const secs = total % 60;

      if (!this.showDays) {
        hours += days * 24;
        days = 0;
      }

      if (this.out.d) this.out.d.textContent = SBTrialCountdown.pad(days);
      if (this.out.h) this.out.h.textContent = SBTrialCountdown.pad(hours);
      if (this.out.m) this.out.m.textContent = SBTrialCountdown.pad(mins);
      if (this.out.s) this.out.s.textContent = SBTrialCountdown.pad(secs);
    }
  }

  if (!customElements.get('sb-trial-countdown')) {
    customElements.define('sb-trial-countdown', SBTrialCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sb-trial-offer"] && !Shopify.designMode) return;
  try {
    class SBTrialOffer extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.variants = this.readJSON('[data-sbt-variants]', []);
      this.flavors  = this.readJSON('[data-sbt-flavors]', []);
      this.tiers    = this.readJSON('[data-sbt-tiers]', []);
      this.media    = this.readJSON('[data-sbt-media]', {});
      this.swapOn   = this.dataset.swapGallery === 'true';

      this.freeLabel    = this.dataset.freeLabel || 'FREE';
      this.saveLabel    = this.dataset.saveLabel || 'SAVE {amount}';
      this.soldOutLabel = this.dataset.soldoutLabel || 'Sold out';
      this.showCompare  = this.dataset.showCompare === 'true';
      this.goCheckout   = this.dataset.goCheckout === 'true';

      this.flavor = this.dataset.defaultFlavor || (this.flavors[0] && this.flavors[0].v) || '';
      this.nights = this.dataset.defaultNights || (this.tiers[0] && this.tiers[0].v) || '';

      this.form     = this.querySelector('.sbt__form');
      this.idInput  = this.querySelector('[data-sbt-id]');
      this.cta      = this.querySelector('[data-sbt-cta]');
      this.ctaLabel = this.querySelector('[data-sbt-cta-label]');

      this.addEventListener('click', this.onClick.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      /* Back from checkout can restore this page from the bfcache with the
         "going to checkout" state still on — clear it. */
      window.addEventListener('pageshow', (ev) => {
        if (ev.persisted) this.endCheckoutMode();
      });

      this.render();
    }

    readJSON(sel, fallback) {
      try {
        const el = this.querySelector(sel);
        return el ? JSON.parse(el.textContent) : fallback;
      } catch (e) {
        return fallback;
      }
    }

    /* "$8.95" / "8,95 €" -> 8.95 */
    static toNumber(str) {
      if (!str) return 0;
      let n = String(str).replace(/[^0-9.,]/g, '');
      if (n.indexOf(',') > -1 && n.indexOf('.') > -1) n = n.replace(/,/g, '');
      else if (n.indexOf(',') > -1) n = n.replace(',', '.');
      return parseFloat(n) || 0;
    }

    /* render a number using the same currency shape as a sample money string */
    static formatLike(sample, value) {
      const m = String(sample || '').match(/[\d.,]+/);
      if (!m) return String(value);
      let out = value.toFixed(2);
      if (m[0].indexOf(',') > -1 && m[0].indexOf('.') === -1) out = out.replace('.', ',');
      return String(sample).replace(m[0], out);
    }

    find(flavor, nights) {
      return this.variants.find((v) => v.f === flavor && v.n === nights) || null;
    }

    onClick(e) {
      const f = e.target.closest('[data-sbt-flavor]');
      if (f && this.contains(f)) {
        const next = f.getAttribute('data-sbt-flavor');
        const changed = next !== this.flavor;
        this.flavor = next;
        this.render();
        if (changed) this.swapGallery();
        return;
      }
      const t = e.target.closest('[data-sbt-tier]');
      if (t && this.contains(t)) {
        this.nights = t.getAttribute('data-sbt-tier');
        this.render();
      }
    }

    render() {
      this.querySelectorAll('[data-sbt-flavor]').forEach((el) => {
        const on = el.getAttribute('data-sbt-flavor') === this.flavor;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      this.querySelectorAll('[data-sbt-tier]').forEach((el) => {
        const nights = el.getAttribute('data-sbt-tier');
        const on = nights === this.nights;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');

        const v = this.find(this.flavor, nights);
        const priceEl   = el.querySelector('[data-sbt-price]');
        const compareEl = el.querySelector('[data-sbt-compare]');
        const saveEl    = el.querySelector('[data-sbt-save]');

        if (!v) {
          if (priceEl) priceEl.textContent = '';
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
          return;
        }

        const price = SBTrialOffer.toNumber(v.price);
        if (priceEl) priceEl.textContent = price === 0 ? this.freeLabel : v.price;

        const showCmp = this.showCompare && v.hasCompare;
        if (compareEl) {
          compareEl.hidden = !showCmp;
          compareEl.textContent = showCmp ? v.compare : '';
        }

        if (saveEl) {
          const diff = SBTrialOffer.toNumber(v.compare) - price;
          const show = showCmp && diff > 0;
          saveEl.hidden = !show;
          saveEl.textContent = show
            ? this.saveLabel.replace('{amount}', SBTrialOffer.formatLike(v.compare, diff))
            : '';
        }
      });

      const current = this.find(this.flavor, this.nights);
      if (this.idInput) this.idInput.value = current ? current.id : '';

      const tier = this.tiers.find((t) => t.v === this.nights);
      if (this.ctaLabel && tier && tier.cta) this.ctaLabel.textContent = tier.cta;

      if (this.cta) {
        const ok = !!(current && current.available);
        this.cta.disabled = !ok;
        if (!ok && this.ctaLabel) this.ctaLabel.textContent = this.soldOutLabel;
      }
    }

    /* ---- gallery: first slide follows the chosen flavour ---- */

    galleryParts() {
      const scope = this.closest('product-component') || this.closest('.product-information') || document;
      const gal = scope.querySelector('media-gallery');
      if (!gal) return null;
      const notZoom = (el) => !el.closest('zoom-dialog');
      const slide = [...gal.querySelectorAll('slideshow-slide')].find(notZoom);
      const zoomRoot = gal.querySelector('zoom-dialog') || document.querySelector('zoom-dialog');
      return {
        img: slide ? slide.querySelector('img') : null,
        thumb: [...gal.querySelectorAll('.slideshow-control img')].find(notZoom) || null,
        zoom: zoomRoot ? zoomRoot.querySelector('img') : null,
        slideshow: [...gal.querySelectorAll('slideshow-component')].find(notZoom) || null
      };
    }

    static snapshot(el) {
      return el ? { src: el.getAttribute('src'), srcset: el.getAttribute('srcset'), alt: el.getAttribute('alt') } : null;
    }

    static paint(el, src, srcset, alt) {
      if (!el || !src) return;
      if (srcset) el.setAttribute('srcset', srcset);
      else el.removeAttribute('srcset');
      el.setAttribute('src', src);
      if (alt != null) el.setAttribute('alt', alt);
    }

    swapGallery() {
      if (!this.swapOn) return;
      const g = this.galleryParts();
      if (!g || !g.img) return;

      /* remember what the theme rendered, so a flavour without its own image
         puts the original hero back */
      if (!this.original) {
        this.original = {
          img: SBTrialOffer.snapshot(g.img),
          thumb: SBTrialOffer.snapshot(g.thumb),
          zoom: SBTrialOffer.snapshot(g.zoom)
        };
      }

      const m = this.media[this.flavor];
      const o = this.original;

      if (m) {
        SBTrialOffer.paint(g.img, m.src, m.srcset, m.alt);
        SBTrialOffer.paint(g.thumb, m.thumb, m.thumbSrcset, m.alt);
        SBTrialOffer.paint(g.zoom, m.zoom, null, m.alt);
      } else {
        if (o.img) SBTrialOffer.paint(g.img, o.img.src, o.img.srcset, o.img.alt);
        if (o.thumb) SBTrialOffer.paint(g.thumb, o.thumb.src, o.thumb.srcset, o.thumb.alt);
        if (o.zoom) SBTrialOffer.paint(g.zoom, o.zoom.src, o.zoom.srcset, o.zoom.alt);
      }

      if (g.slideshow && typeof g.slideshow.select === 'function' && g.slideshow.current !== 0) {
        try { g.slideshow.select(0); } catch (e) { /* theme API changed — the image still swapped */ }
      }
    }

    onSubmit(e) {
      const current = this.find(this.flavor, this.nights);
      if (!current || !current.available) {
        e.preventDefault();
        return;
      }
      /* No JS-capable cart? let the native POST happen. */
      if (!window.fetch) return;

      e.preventDefault();
      this.cta.classList.add('is-loading');

      /* The theme opens its cart drawer as soon as anything is added, and the
         hop to /checkout takes ~1s, so the drawer flashed. Hide and close it
         for the length of the trip. */
      if (this.goCheckout) this.startCheckoutMode();

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r)))
        .then(() => {
          if (this.goCheckout) {
            window.location.href = '/checkout';
          } else {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
            this.cta.classList.remove('is-loading');
          }
        })
        .catch(() => {
          this.endCheckoutMode();
          this.form.submit();
        });
    }

    startCheckoutMode() {
      document.documentElement.classList.add('sbt-to-checkout');
      const closeDrawer = () => {
        document
          .querySelectorAll('#cart-drawer dialog[open], dialog.sb-cd-dialog[open], dialog.color-custom-drawer[open]')
          .forEach((d) => { try { d.close(); } catch (err) {} });
      };
      closeDrawer();
      if (this.drawerWatch) this.drawerWatch.disconnect();
      this.drawerWatch = new MutationObserver(closeDrawer);
      this.drawerWatch.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
    }

    endCheckoutMode() {
      document.documentElement.classList.remove('sbt-to-checkout');
      if (this.drawerWatch) {
        this.drawerWatch.disconnect();
        this.drawerWatch = null;
      }
      if (this.cta) this.cta.classList.remove('is-loading');
    }
  }

  if (!customElements.get('sb-trial-offer')) {
    customElements.define('sb-trial-offer', SBTrialOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
